import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class ProjectListNavigation extends Component {

    navigateHandler(obj, e) {
        e.preventDefault()
        this.props.clickHandler(obj);
    }

    render() {
        const { projects } = this.props
        let links = [];

        if (projects.length) {
            projects.map(project => {
                return links.push(
                    <li key={project.slug} className="c-slideshow__nav-list-item" data-selected={this.props.currentTab === project.slug}>
                        <Link onClick={(e) => this.navigateHandler('#' + project.slug, e)} className="c-slideshow__nav-link u-unstyled" to={"/work/" + project.slug}>
                            {project.title}
                        </Link>
                    </li>
                );
            });
        }

        return (
            <ul className="c-slideshow__nav-list">
                {links}
            </ul>
        )
    }
}

export default ProjectListNavigation


// WEBPACK FOOTER //
// ./src/components/Project/ProjectListNavigation.js